import { SITE_URL } from './routeMeta';

// Build-time constant - substituted by Vite's import.meta.env replacement.
// When false, the bundler dead-code-eliminates the setCanonical() call below.
const ALLOW_INDEXING = import.meta.env.VITE_ALLOW_INDEXING === 'true';

function setMeta(name: string, content: string, attr: 'name' | 'property' = 'name') {
  let el = document.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href: string) {
  let el = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export type PageMeta = {
  title: string;
  description: string;
  path?: string;
};

export function applyPageMeta({ title, description, path = '/' }: PageMeta): void {
  const url = `${SITE_URL}${path}`;
  document.title = title;
  setMeta('description', description);
  setMeta('og:title', title, 'property');
  setMeta('og:description', description, 'property');
  setMeta('og:url', url, 'property');
  setMeta('twitter:title', title);
  setMeta('twitter:description', description);
  if (ALLOW_INDEXING) setCanonical(url);
}
